import {FeatureGrid, type FeatureGridPropsData} from '../../generic/FeatureGrid/FeatureGrid'
import Styles from './FeaturesSection.module.css'

export interface FeaturesSectionProps {
  items: [FeatureGridPropsData, FeatureGridPropsData]
}

export const defaultProps: Partial<FeaturesSectionProps> = {}

export const FeaturesSection = (props: FeaturesSectionProps) => {
  const initializedProps: FeaturesSectionProps = {...defaultProps, ...props}
  const {items} = initializedProps

  return (
    <div className={Styles['FeaturesSection']}>
      {items.map((item, index) => (
        <FeatureGrid
          // eslint-disable-next-line @eslint-react/no-array-index-key
          key={`feature-grid-${index}`}
          {...item}
          hasColorDivider={!index}
          layout={!index ? 'two-column' : 'two-then-three'}
        />
      ))}
    </div>
  )
}
